<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="学生名字" prop="dbColumn_name">
								<el-input   :readonly="true"  v-model="formParameter.dbColumn_name" autocomplete="off"></el-input>
							</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="24">
						<el-form-item label="推送类型" prop="thejobtype">
							<select-option-dictionary v-model="formParameter.thejobtype"
								dkey="ts-type"></select-option-dictionary>
						</el-form-item> </el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="推送方式" prop="method">
							<select-option-dictionary v-model="formParameter.method"
								dkey="ts-method"></select-option-dictionary>
						</el-form-item> </el-col>
				</el-row>
				<el-row>
				  <el-col :span="24">
					<el-form-item label="是否自动推送" prop="isauto">
						<el-switch
							v-model="isauto"
							active-color="#13ce66"
							inactive-color="#ff4949">
						</el-switch>
					</el-form-item>
				  </el-col>
				</el-row>
				<el-row>
					<el-col :span="24" v-if="isauto">
						<el-form-item label="推送时间" prop="chetime">
							<el-date-picker value-format="yyyy-MM-dd HH:mm:ss" placeholder="不选默认立即推送"
								v-model="formParameter.chetime" type="datetime" align="right" rule="rules">
							</el-date-picker>
						</el-form-item> </el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="内容" prop="content">
							<el-input type="textarea" row="3" v-model="formParameter.content" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>


			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/tuisong.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			valuex:'',  //站位
			stuList: [],   //会员备选列表
			isauto: true, //是否自动推送
			rules: {
				 
				//内容
				content: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],
				chetime: [
					{
						validator: this.checkChetime,
						trigger: 'blur'
					}
				]

			}
		};
	},
	methods: {
		checkChetime(rule, value, callback) {
    const currentTimestamp = Date.now();
    const selectedTimestamp = new Date(value).getTime();

    if (selectedTimestamp < currentTimestamp) {
      callback(new Error('警告：选定时间早于当前时间'));
    } else {
      callback();
    }
  }, handleSelect(item) {
			this.formParameter.sid = item.sid
		    //console.log(item);
		},

		//打开弹框
		open(parameter, title, disabled, size) {
			this.formParameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			 
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {

 
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				this.formParameter.isauto = this.isauto ? 1 : 0;
				if (!this.parameter.id) {
					//添加
					let parameter = this.$utils.merger(this.formParameter);
					api.save(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		}
	 
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
